// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flexrow {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-around;\n\tflex-wrap: wrap;\n}", ""]);
// Exports
module.exports = exports;
